var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useCallback, useMemo, useReducer } from "react";
import { convertToLocalDate } from "../helpers";
import { Modes } from "../Models/MainProps";
var ControlActionTypeEnum;
(function (ControlActionTypeEnum) {
    ControlActionTypeEnum[ControlActionTypeEnum["toggle"] = 0] = "toggle";
    ControlActionTypeEnum[ControlActionTypeEnum["setMode"] = 1] = "setMode";
    ControlActionTypeEnum[ControlActionTypeEnum["setDay"] = 2] = "setDay";
    ControlActionTypeEnum[ControlActionTypeEnum["setMonth"] = 3] = "setMonth";
    ControlActionTypeEnum[ControlActionTypeEnum["setYear"] = 4] = "setYear";
    ControlActionTypeEnum[ControlActionTypeEnum["nextYear"] = 5] = "nextYear";
    ControlActionTypeEnum[ControlActionTypeEnum["prevYear"] = 6] = "prevYear";
    ControlActionTypeEnum[ControlActionTypeEnum["setYearPageNumber"] = 7] = "setYearPageNumber";
    ControlActionTypeEnum[ControlActionTypeEnum["setPopupStyles"] = 8] = "setPopupStyles";
    ControlActionTypeEnum[ControlActionTypeEnum["setInnerValue"] = 9] = "setInnerValue";
})(ControlActionTypeEnum || (ControlActionTypeEnum = {}));
var reducer = function (state, action) {
    switch (action.type) {
        case ControlActionTypeEnum.toggle:
            return __assign(__assign({}, state), { open: action.payload });
        case ControlActionTypeEnum.setMode:
            return __assign(__assign({}, state), { mode: action.payload });
        case ControlActionTypeEnum.setDay:
            return __assign(__assign({}, state), { day: action.payload });
        case ControlActionTypeEnum.setMonth:
            return __assign(__assign({}, state), { month: action.payload });
        case ControlActionTypeEnum.setYear:
            return __assign(__assign({}, state), { year: action.payload });
        case ControlActionTypeEnum.nextYear:
            return state.mode === Modes.years ? __assign(__assign({}, state), { yearPageNumber: state.yearPageNumber + 1 }) : __assign(__assign({}, state), { year: state.year + 1 });
        case ControlActionTypeEnum.prevYear:
            return state.mode === Modes.years ? __assign(__assign({}, state), { yearPageNumber: state.yearPageNumber - 1 }) : __assign(__assign({}, state), { year: state.year > 1 ? state.year - 1 : 1 });
        case ControlActionTypeEnum.setYearPageNumber:
            return __assign(__assign({}, state), { yearPageNumber: action.payload });
        case ControlActionTypeEnum.setPopupStyles:
            return __assign(__assign({}, state), { popupStyle: action.payload });
        case ControlActionTypeEnum.setInnerValue:
            return __assign(__assign({}, state), { year: action.payload.y, month: action.payload.m, day: action.payload.d });
        default:
            return state;
    }
};
var formatter = function (date, format) {
    return format ? format.replace("0", date.y.toString()).replace("1", date.m.toString()).replace("2", date.d.toString()) :
        "".concat(date.y, "/").concat(date.m, "/").concat(date.d);
};
var useControl = function (props) {
    var init = useMemo(function () {
        var res = props.value;
        if (res) {
            var arr = res.split("/");
            var y = props.locale.numberConverter(arr[0]);
            var m = props.locale.numberConverter(arr[1]);
            var d = props.locale.numberConverter(arr[2]);
            if (!isNaN(y) && !isNaN(m) && !isNaN(d)) {
                return [y, m, d];
            }
        }
        var dt = convertToLocalDate(new Date(), props.locale);
        return [dt[0], dt[1], dt[2]];
    }, []);
    var _a = useReducer(reducer, {
        mode: Modes.days,
        year: init[0],
        month: init[1],
        day: init[2],
        open: false,
        yearPageNumber: 0
    }), state = _a[0], dispatch = _a[1];
    var handleFocus = function () {
        var _a;
        var inputRect = (_a = props.anPickerRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
        if (inputRect)
            setPopupStyles({
                left: props.locale.rtl ? "auto" : inputRect.left,
                right: props.locale.rtl ? window.innerWidth - inputRect.right : "auto",
                top: inputRect.top + inputRect.height,
            });
        toggle(true);
    };
    var handleBlure = function () {
        if (!props.value) {
            return;
        }
        var arr = props.value.split('/');
        if (arr.length !== 3) {
            return;
        }
        var y = props.locale.numberConverter(arr[0]);
        var m = props.locale.numberConverter(arr[1]);
        var d = props.locale.numberConverter(arr[2]);
        if (isNaN(y) || isNaN(m) || isNaN(d)) {
            return;
        }
        dispatch({
            type: ControlActionTypeEnum.setInnerValue, payload: {
                y: y,
                m: m,
                d: d
            }
        });
    };
    var toggle = useCallback(function (open) {
        dispatch({ type: ControlActionTypeEnum.toggle, payload: open });
    }, []);
    var setPopupStyles = useCallback(function (styles) {
        dispatch({ type: ControlActionTypeEnum.setPopupStyles, payload: styles });
    }, []);
    var handleChange = useCallback(function (e) {
        var v = e.target.value;
        console.log("handleChange", v);
        if (!v) {
            props.onChange('');
            return;
        }
        var arr = v.split(props.value);
        var y = props.locale.numberConverter(arr[0]);
        var m = props.locale.numberConverter(arr[1]);
        var d = props.locale.numberConverter(arr[2]);
        props.onChange("".concat(y, "/").concat(m, "/").concat(d));
        dispatch({
            type: ControlActionTypeEnum.setInnerValue, payload: {
                y: y,
                m: m,
                d: d
            }
        });
    }, []);
    var onSelectYear = function (newYear) {
        dispatch({
            type: ControlActionTypeEnum.setYear, payload: newYear
        });
        dispatch({
            type: ControlActionTypeEnum.setMode, payload: Modes.days
        });
        //props.onChange(formatter({ y: newYear, m: state.month, d: 1 }))
    };
    var onSelectMonth = function (newMonth) {
        dispatch({
            type: ControlActionTypeEnum.setMonth, payload: newMonth
        });
        dispatch({
            type: ControlActionTypeEnum.setMode, payload: Modes.days
        });
        //props.onChange(formatter({ y: state.year, m: newMonth, d: 1 }))
    };
    var onSelectDay = function (newDay) {
        dispatch({
            type: ControlActionTypeEnum.setDay, payload: newDay
        });
        props.onChange(formatter({ y: state.year, m: state.month, d: newDay }));
        toggle(false);
    };
    var setMode = useCallback(function (newMode) {
        dispatch({
            type: ControlActionTypeEnum.setMode, payload: newMode
        });
    }, []);
    var nextYear = useCallback(function () {
        dispatch({ type: ControlActionTypeEnum.nextYear });
    }, []);
    var prevYear = useCallback(function () {
        dispatch({ type: ControlActionTypeEnum.prevYear });
    }, []);
    var nextMonth = useCallback(function () {
        dispatch({ type: ControlActionTypeEnum.setDay, payload: 1 });
        dispatch({ type: ControlActionTypeEnum.setMonth, payload: state.month === 12 ? 1 : state.month + 1 });
        dispatch({ type: ControlActionTypeEnum.setMode, payload: Modes.days });
    }, []);
    var prevMonth = useCallback(function () {
        dispatch({ type: ControlActionTypeEnum.setDay, payload: 1 });
        dispatch({ type: ControlActionTypeEnum.setMonth, payload: state.month === 1 ? 12 : state.month - 1 });
        dispatch({ type: ControlActionTypeEnum.setMode, payload: Modes.days });
    }, []);
    var setToday = function () {
        var eqDateArr = convertToLocalDate(new Date(), props.locale);
        dispatch({
            type: ControlActionTypeEnum.setInnerValue, payload: {
                y: eqDateArr[0],
                m: eqDateArr[1],
                d: eqDateArr[2]
            }
        });
        props.onChange(formatter({
            y: eqDateArr[0],
            m: eqDateArr[1],
            d: eqDateArr[2]
        }));
        toggle(false);
    };
    return {
        state: state,
        toggle: toggle,
        setPopupStyles: setPopupStyles,
        handleFocus: handleFocus,
        handleBlure: handleBlure,
        handleChange: handleChange,
        setMode: setMode,
        nextYear: nextYear,
        prevYear: prevYear,
        nextMonth: nextMonth,
        prevMonth: prevMonth,
        onSelectYear: onSelectYear,
        onSelectMonth: onSelectMonth,
        onSelectDay: onSelectDay,
        setToday: setToday
    };
};
export default useControl;
